import styled from '@emotion/styled'
import { css } from '@emotion/react'

const wrapperInlineStyles = ({ theme }) => css`
  label: wrapper-inline;

  display: grid;
  margin-bottom: ${theme.spacings.mega};
  grid-gap: ${theme.spacings.mega};
  grid-template-columns: 1fr;

  ${theme.media.kilo} {
    grid-template-columns: 1fr 1fr;
  }

  ${theme.media.mega} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${theme.media.giga} {
    grid-template-columns: repeat(4, 1fr);
  }
`

export const WrapperInline = styled('div')(wrapperInlineStyles)
